export default __webpack_public_path__ + "static/media/hazard_map.73ef58b4.jpg";